import React, { useEffect, useState } from 'react';
import { Box, Container, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { toast } from 'react-toastify';
import PageHeader from '../common/banner/pageHeader';
import ClassificationBannerHeader from '../common/banner/classifactionBannerHeader';

export default function Groups() {

    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                
                const response = await fetch(`${process.env.REACT_APP_API}/groups/`);            
                if (!response.ok) {
                    toast.error(`HTTP error! status: ${response.status}`);
                } else {
                    const json = await response.json();
                    setData(json.data);
                }
            } catch (error) {
                toast.error(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
            <Box sx={{pt: 2}}>
                <ClassificationBannerHeader></ClassificationBannerHeader>
                <PageHeader title="Groups"></PageHeader>
            </Box>
            <Box>
                <TableContainer component={Paper} sx={{ mt: 4 }}>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow sx={{ backgroundColor: '#0568AE' }}>
                                <TableCell align="justify" sx={{ color: 'white' }}>Group Name</TableCell>
                                <TableCell align="justify" sx={{ color: 'white' }}>Description</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data.map((row, index) => (
                                <TableRow key={row.id} sx={{ backgroundColor: index % 2 === 0 ? '#2A2A2A' : '#000000' }}>
                                    <TableCell sx={{ color: 'white' }} component="th" scope="row">
                                        {row.name}
                                    </TableCell>
                                    <TableCell sx={{ color: 'white' }} align="justify">{row.description}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Container>
    )
}
